import { TranslationWaterAdditionByTravelMessages } from "../interfaces/waterAdditionByTravelMessages";

const waterAdditionByTravelMessages: TranslationWaterAdditionByTravelMessages = {
  "waterAdditionByTravel.title": "Adição de Água por Viagem",
  "waterAdditionByTravel.waterAdditionByTravel": "Adição de Água por Viagem",
  "waterAdditionByTravel.filterTitle": "Filtrar Adições de Água por Viagem",
  "waterAdditionByTravel.fleetCode": "Frota",
  "waterAdditionByTravel.licensePlate": "Placa",
  "waterAdditionByTravel.startDate": "Data Início",
  "waterAdditionByTravel.finishDate": "Data Fim",
  "waterAdditionByTravel.driver": "Motorista",
  "waterAdditionByTravel.document": "Doc.",
  "waterAdditionByTravel.volume": "Volume",
  "waterAdditionByTravel.reassignedPostDischarge": "Pós-descarga (viagem anterior)",
  "waterAdditionByTravel.originTravelDoc": "Doc. viagem de origem",
  "waterAdditionByTravel.preDischarge": "Pré-descarga (L)",
  "waterAdditionByTravel.postDischarge": "Pós-descarga (L)",
  "waterAdditionByTravel.noDataFound": "Nenhuma adição de água encontrada para o período selecionado",
  "waterAdditionByTravel.minWater": "Água Mín.",
  "waterAdditionByTravel.maxWater": "Água Máx.",
  "waterAdditionByTravel.waterTotal": "Água Total (L)",
  "waterAdditionByTravel.waterAdditionTitle": "Adição de Água",
  "waterAdditionByTravel.analyticTabTitle": "Analítico",
  "waterAdditionByTravel.syntheticTabTitle": "Sintético"
};

export const messages = waterAdditionByTravelMessages;
